export default __webpack_public_path__ + "static/media/map-marker-duotone.5368322e.svg";